'use strict';

let injected;
/**
 * Checks if we're running in shady dom mode
 */
function isShadyDom() {
    return !!window.ShadyDOM;
}
/**
 * Removes unsupported host and slotted rules from pre-processed
 * style scoped css.
 * @param code CSS code to modify
 */
function removeUnsupportedCss(code) {
    return code.replace(/(,?[^,;\{\}]*)\:?\:(slotted|host)(\(.+?\))?,?/gi, '');
}
function createNode(source, shadowOrHead, scopeId) {
    if (isShadyDom()) {
        if (injected && injected.includes(scopeId)) {
            // Already injected this content can ignore.
            return;
        }
        source = removeUnsupportedCss(source);
        injected = injected || [];
        injected.push(scopeId);
        shadowOrHead = document.head;
    }
    const style = document.createElement('style');
    style.appendChild(document.createTextNode(source));
    shadowOrHead.appendChild(style);
}
function createInjectorShadow(shadowOrHead, scopeId) {
    return (_, { source }) => {
        if (!Array.isArray(source)) {
            source = [source];
        }
        for (const css of source) {
            createNode(css && css.toString(), shadowOrHead, scopeId);
        }
    };
}
function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate) {
    const options = typeof script === 'function' ? script.options : script; // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true; // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    if (scopeId) {
        options._scopeId = scopeId;
    }
    if (style) {
        const hook = function () {
            style.call(this, createInjectorShadow(this.$root.$options.shadowRoot || document.head, scopeId));
        };
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing
                ? [].concat(existing, hook)
                : [hook];
        }
    }
    return script;
}
module.exports = normalizeComponent;
